"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CantModifyParamError = exports.ParamType = exports.ModifyModes = void 0;
var tslib_1 = require("tslib");
var ModifyModes;
(function (ModifyModes) {
    ModifyModes["Set"] = "set";
    ModifyModes["Reset"] = "reset";
    ModifyModes["ResetAll"] = "resetAll";
    ModifyModes["PublishEvent"] = "publishEvent";
})(ModifyModes = exports.ModifyModes || (exports.ModifyModes = {}));
var ParamType;
(function (ParamType) {
    ParamType["Setting"] = "Settings";
    ParamType["Styles"] = "Styles";
})(ParamType = exports.ParamType || (exports.ParamType = {}));
var CantModifyParamError = /** @class */ (function (_super) {
    tslib_1.__extends(CantModifyParamError, _super);
    function CantModifyParamError(mode, type) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nCan't modify ".concat(type, " values from current environment.\nPlease make sure you are not using `").concat(type, ".").concat(mode, "(...)` from the widget part.\n")) || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return CantModifyParamError;
}(Error));
exports.CantModifyParamError = CantModifyParamError;
//# sourceMappingURL=CantModifyParamError.js.map